import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationComponent } from './notification.component';
import { ConnectionsComponent } from '../connections/connections.component';
import { MaterialModule } from '../utilities/modules/material.module';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';


@NgModule({
  declarations: [
    NotificationComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    MatIconModule,
    MatDialogModule
  ],
  exports: [NotificationComponent],
})
export class NotificationModule {
  connectionsComponent = ConnectionsComponent.self;
 }
